import { getConfig } from '@/app/config'

export const toggles = {
  datadogRum: true,
  datadogSessionReplay: true,
  themeSwitcher: false,
} as const

export type Toggle = keyof typeof toggles

const getToggleStatesFromEnvironment = (): Partial<Record<Toggle, boolean>> => {
  let featureToggles: string
  try {
    featureToggles = getConfig().FEATURE_TOGGLES ?? ''
  } catch {
    // Must not log here: logging errors checks toggles, which reads config —
    // logging a config failure from this catch would recurse infinitely.
    return {}
  }
  const environmentStates = featureToggles
    .split(/\s*,\s*/)
    .map((item) => item.trim())
    .filter(Boolean)
  return Object.keys(toggles).reduce((acc, key) => {
    if (environmentStates.includes(key) && !environmentStates.includes(`-${key}`)) {
      return {
        ...acc,
        [key]: true,
      }
    }
    if (environmentStates.includes(`-${key}`)) {
      return {
        ...acc,
        [key]: false,
      }
    }
    return acc
  }, {})
}

export const getToggleStates = (): Record<Toggle, boolean> => {
  const state = {
    ...toggles,
    ...getToggleStatesFromEnvironment(),
  }
  return state
}

export const isEnabled = (toggle: Toggle): boolean => {
  const state = getToggleStates()
  return state[toggle]
}
